import React, { useState, useEffect, createContext } from "react";
import { Routes, Route } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Results } from "./Results";
import { ProfilePages } from "./ProfilePage";
import { TheSearchPage } from "./SearchPage";
import { LandingPage } from "./LandingPage";
import { Quiz } from "./Quiz";
import SignInPage from "./SignIn";
import { ProtectedRoute } from "./ProtectedRoute"; 
import { TheNavbar } from "./Navbar";

export const AuthContext = createContext(null);

export default function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });
  }, []);

  const signOut = () => {
    const auth = getAuth();
    auth
      .signOut()
      .then(() => {
        setCurrentUser(null);
      })
      .catch((error) => {
        console.error("Sign Out Error", error);
      });
  };

  return (
    <AuthContext.Provider value={{ currentUser, signOut }}>
      <div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/results" element={<Results />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePages />
              </ProtectedRoute>
            }
          />
          <Route path="/search" element={<TheSearchPage />} />
          <Route
            path="/quiz"
            element={
              <ProtectedRoute>
                <Quiz />
              </ProtectedRoute>
            }
          />
          <Route path="/signin" element={<SignInPage />} />
        </Routes>
      </div>
    </AuthContext.Provider>
  );
}
